export const CONSULTAR_SOLICITUD = "@recepcion-documental/CONSULTAR_SOLICITUD";
export const SOLICITUD_CONSULTADA = "@recepcion-documental/SOLICITUD_CONSULTADA";
export const ERROR_CONSULTANDO_SOLICITUD = "@recepcion-documental/ERROR_CONSULTANDO_SOLICITUD";

export const CONSULTAR_TIPOS_SOLICITUD = "@recepcion-documental/CONSULTAR_TIPOS_SOLICITUD";
export const TIPOS_SOLICITUD_CONSULTADOS = "@recepcion-documental/TIPOS_SOLICITUD_CONSULTADOS";
export const ERROR_CONSULTANDO_TIPOS_SOLICITUD = "@recepcion-documental/ERROR_CONSULTANDO_TIPOS_SOLICITUD";

export const LIMPIAR_BUSQUEDA_SOLICITUD = "@recepcion-documental/LIMPIAR_BUSQUEDA_SOLICITUD";
